import React, { forwardRef, type ComponentType } from "react";
import { twMerge } from "tailwind-merge";

interface ICustomerStorageOptionButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  Icon?: ComponentType<React.SVGProps<SVGSVGElement>>;
  iconClassName?: string;
}

export const CustomerStorageOptionButton = forwardRef<
  HTMLButtonElement,
  ICustomerStorageOptionButtonProps
>((props, ref) => {
  const { className, Icon, iconClassName, children, ...rest } = props;

  return (
    <button
      className={twMerge(
        "items-centerp-4 group flex w-full p-4 text-left font-medium leading-6 transition-colors hover:bg-grey-light hover:text-base-black",
        className,
      )}
      ref={ref}
      {...rest}
    >
      <div className="flex items-center gap-3">
        {Icon && (
          <Icon className={twMerge("h-5 w-5 text-grey-dark", iconClassName)} />
        )}
        {children}
      </div>
    </button>
  );
});
